export const grantStatus = {
    1: "Normal",
    2: "Alerta",
    3: "Crítico",
    4: "Excedido",
    5: "Sem comunicação",
    6: "Trabalhando fora do cronograma",
    7: "Trabalhou fora do cronograma",
    8: "Inativo",
    9: "Vencido",
    10: "Fora do cronograma",
};